<template>
	<div>
		<h4 class="font_lg font_bold text-center" style="width:520px;margin:0 auto; padding-bottom: 50px;">Document download</h4>

		<table class="center" style="padding-bottom: 100px;">
			<tr>
				<th>Invoice documents:</th>
				<th>Other documents:</th>
			</tr>
			<tr>
				<td>
					<a :href="invoicesZipLink || buildDocumentDownloadUrl(invoice.fileId, token)" target="_blank">
						{{ invoicesZipLink ? 'invoices.zip' : invoice.fileName }}
					</a>
				</td>
				<td>
					<a :href="additionalDocumentsZipLink || buildDocumentDownloadUrl(additionalDocuments && additionalDocuments[0] ? additionalDocuments[0].fileId : '', token)" target="_blank">
						{{ additionalDocumentsZipLink ? 'additional_documents.zip' : additionalDocuments && additionalDocuments[0] ? additionalDocuments[0].fileName : "" }}
					</a>
				</td>
			</tr>
			<template v-for="(additionalDocument, index) in additionalDocuments">
				<tr v-if="index > 0">
					<td></td>
					<td>
						<a :href="buildDocumentDownloadUrl(additionalDocument.fileId, token)" target="_blank"> {{ additionalDocument.fileName }}</a>
					</td>
				</tr>
			</template>
		</table>
	</div>
</template>
<script>
import {fileuploadApi} from "@/common/api/fileuploadApi";
import {receivableApi} from "src/common/api/receivableApi";

export default {
	data() {
		return {
			purpose: "",
			token: "",
			invoice: {},
			additionalDocuments: [],
			invoicesZipLink: "",
			additionalDocumentsZipLink: ""
		};
	},
	beforeMount() {
		let { query } = this.$route;
		if (query && query.token) {
			this.token = query.token;
			this.purpose = query.purpose;

			receivableApi
				.allReceivableDocuments(this.token, this.purpose)
				.then(res => {
					this.invoice = res.invoice;
					this.additionalDocuments = res.additionalDocuments;
					this.invoicesZipLink = res.invoicesZipLink;
					this.additionalDocumentsZipLink = res.additionalDocumentsZipLink;
				})
				.catch(this.toast);
		}
	},
	methods: {
		buildDocumentDownloadUrl(fileId, token) {
			return fileuploadApi.getPdfViaTokenUrl(fileId, token);
		}
	}
};
</script>
<style lang="scss" scoped>
.center {
	margin-left: auto;
	margin-right: auto;
}

td {min-width: 350px;
	max-width: 350px;
	padding-left: 100px
}

th {
	text-align: left;
	padding-left: 100px;
}
</style>